"use client";

import { Stack } from "@/components/ui/stack";

import type { NavigationConfig } from "@/config/nav";

import { NavigationLinkItem } from "./navigation-link-item";
import { NavigationMenuItem } from "./navigation-menu-item";
import { WordMark } from "./word-mark";

export function MainNav({
  title,
  config,
}: {
  title?: string;
  config: NavigationConfig;
}) {
  return (
    <nav className="mr-4 hidden md:flex">
      <Stack gap={2} direction="row" align="center">
        <WordMark title={title} />
        {config.map((item) =>
          item.kind === "menu" ? (
            <NavigationMenuItem key={item.label} item={item} />
          ) : (
            <NavigationLinkItem key={item.label} item={item} />
          ),
        )}
      </Stack>
    </nav>
  );
}
